"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _utils = require("composer-lib/lib/utils");

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _immutable = require("immutable");

var _UIAlert = _interopRequireDefault(require("UIComponents/alert/UIAlert"));

var DEFAULT_TIMEOUT = 7000;
var Toast = (0, _createReactClass.default)({
  displayName: "Toast",
  propTypes: {
    removeToast: _propTypes.default.func,
    toastData: _propTypes.default.instanceOf(_immutable.Map).isRequired
  },
  componentDidMount: function componentDidMount() {
    var toastData = this.props.toastData;
    var fadeAway = toastData.getIn(['toast', 'fadeAway']);
    var timeout = toastData.getIn(['toast', 'timeout'], DEFAULT_TIMEOUT);

    if (fadeAway) {
      this.timeout = setTimeout(this.handleClose, timeout);
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    clearTimeout(this.timeout);
  },
  handleClose: function handleClose() {
    var _this$props = this.props,
        removeToast = _this$props.removeToast,
        toastData = _this$props.toastData;
    clearTimeout(this.timeout);
    (0, _utils.callIfPossible)(toastData.getIn(['toast', 'onClose']));
    removeToast(toastData.get('key'));
  },
  render: function render() {
    var toastData = this.props.toastData;
    var opts = toastData.getIn(['toast', 'opts']);
    var titleText = toastData.getIn(['toast', 'titleI18n']);
    return _react.default.createElement(_UIAlert.default, {
      className: "toast-alert m-bottom-4",
      closeable: true,
      onClose: this.handleClose,
      titleText: titleText,
      type: toastData.getIn(['toast', 'type'])
    }, _react.default.createElement(_FormattedHTMLMessage.default, {
      message: toastData.getIn(['toast', 'textI18n']),
      options: opts
    }));
  }
});
var _default = Toast;
exports.default = _default;
module.exports = exports.default;